"use client"

import * as React from "react"

import { cn } from "../../lib/utils"

export interface RunningMessageCardProps extends React.HTMLAttributes<HTMLDivElement> {
  message: React.ReactNode
  Icon?: React.ComponentType<{ className?: string }>
  iconClassName?: string
  messageClassName?: string
  animate?: boolean
  animationClassName?: string
}

export function RunningMessageCard({
  message,
  Icon,
  className,
  iconClassName,
  messageClassName,
  animate = true,
  animationClassName = "build-profile-carousel-message",
  ...props
}: RunningMessageCardProps) {
  const animationClass = animate ? animationClassName : undefined

  return (
    <div
      className={cn(
        "flex items-center gap-2 px-3 py-4 min-h-16 text-gray-500 bg-[#FFF7E5] border border-[#FFE8CB] rounded-lg",
        className
      )}
      {...props}
    >
      <div className="flex items-center gap-2 min-h-8">
        {Icon ? (
          <Icon
            className={cn(
              "w-4 h-4 shrink-0",
              animationClass,
              iconClassName
            )}
          />
        ) : null}
        <div className="relative flex-1 min-w-0 overflow-hidden">
          <span className={cn("text-xs leading-snug", animationClass, messageClassName)}>
            {message}
          </span>
        </div>
      </div>
    </div>
  )
}
